import React from 'react';

import './styles.scss';

import NavBar from './components/NavBar';

/* eslint-disable */
export default props => (
  <div className={props.className}>
    <header className="header">
      <NavBar changeTab={props.changeTab}/>
    </header>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Header/index.js